// extracted by mini-css-extract-plugin
module.exports = {"header":"_116PgHV","body":"_1iDzvwI"};